import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import moment from 'moment';
import {ReplaySubject} from 'rxjs';
import {startWith, takeUntil} from 'rxjs/operators';
import {
  MEETING_TYPE_ENTRANCE_EXAM,
  MEETING_TYPE_EXAM,
} from '../../../shared/services/dict.service';
import {FilterService} from '../../../shared/services/filter.service';
import {MeetingService} from '../../../shared/services/meeting.service';
import {Meeting} from '../../../shared/interface/meeting';
import {CountedAndPaginated} from '../../../shared/interface/response/counted-and-paginated';

@Component({
  selector: 'app-meetings-calendar',
  templateUrl: './meetings-calendar.component.html',
  styleUrls: ['./meetings-calendar.component.scss']
})
export class MeetingsCalendarComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  form: FormGroup;
  monthControl: FormControl;
  examsControl: FormControl;
  iddTrainingsControl: FormControl;
  newAgentTrainingControl: FormControl;

  meetings: Meeting[] = [];
  daysInMonth: number;
  firstWeekdayOfMonth: number;
  rows = 0;

  constructor(
    private fb: FormBuilder,
    private filterService: FilterService,
    private meetingService: MeetingService,
  ) {
    const date = moment();
    date.startOf('month');

    this.form = fb.group({
      month: this.monthControl = fb.control(date),
      exams: this.examsControl = fb.control(true),
      iddTrainings: this.iddTrainingsControl = fb.control(true),
      newAgentTraining: this.newAgentTrainingControl = fb.control(true),
    });
  }

  ngOnInit(): void {
    this.form.valueChanges
      .pipe(
        startWith(this.monthControl.value),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => {
        const val = this.monthControl.value;
        val.startOf('month');
        this.daysInMonth = val.daysInMonth();

        let weekday = val.weekday();
        if (weekday === 0) {
          weekday = 7;
        }

        this.firstWeekdayOfMonth = weekday;

        this.rows = Math.ceil((this.daysInMonth + this.firstWeekdayOfMonth - 1) / 7);
        this.loadData();
      });

    this.meetingService.meetingListSubject
      .pipe(takeUntil(this.destroyed$))
      .subscribe((result: CountedAndPaginated<Meeting>) => {
        this.meetings = result.items;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadData(): void {
    const filters: any = {};
    filters.month = this.monthControl.value;
    filters.typeKey = [];

    if (this.examsControl.value) {
      filters.typeKey.push(MEETING_TYPE_EXAM, MEETING_TYPE_ENTRANCE_EXAM);
    }

    // if (this.iddTrainingsControl.value) {
    //   filters.typeKey.push(MEETING_TYPE_IDD_TRAINING);
    // }
    //
    // if (this.newAgentTrainingControl.value) {
    //   filters.typeKey.push(MEETING_TYPE_NEW_AGENT_TRAINING);
    // }

    this.meetingService.loadList(0, 9999999, filters);
  }

  getEvents(day: number): Meeting[] {
    const meetings = [];

    this.meetings.forEach((meeting: Meeting) => {
      const startsAtDate = moment(meeting.startsAt);

      if (startsAtDate.date() === day) {
        meetings.push(meeting);
      }
    });

    return meetings;
  }

  addMonth(): void {
    const month = this.monthControl.value;
    month.add(1, 'M');
    this.monthControl.setValue(month);
  }

  subtractMonth(): void {
    const month = this.monthControl.value;
    month.subtract(1, 'M');
    this.monthControl.setValue(month);
  }
}
